module.exports = __webpack_public_path__ + "img/tire-pressure-warning.00d7a537.svg";